import { render, staticRenderFns } from "./PaginationHandler.vue?vue&type=template&id=d3b26b0c&"
import script from "./PaginationHandler.vue?vue&type=script&lang=js&"
export * from "./PaginationHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports